module.exports = __webpack_public_path__ + "media/images/pc/stores/nagoya/access/nagoya_point3_4-2584e11bffcfbd0bc939434c311c65d5.jpg";